module.exports = __webpack_public_path__ + "static/media/mapPin.61ff5f7b.svg";